import React, {Fragment} from 'react'
import Section from './Section'
import styles from '../../styles/modules/common/features.module.scss'
import {isMobile, isTablet} from 'react-device-detect';
import {getStaticPath} from '../../utils';

interface  Props{
    title?: string,
    withSubtitle: boolean,
    features : {
        featureTitle?: string,
        featureImage: {
            mobile?:string,
            desktop?:string,
            default?:string,
        },
        featureText: string,
    }[]
    className?:string,
    itemClassName?:string,
    sectionClass?:string,
    isGreyBackground?:boolean,
    elementID?:string,
}


const getImage = (imageDict) => {
    if (typeof imageDict == 'object' ) {
        let image;
        if(isMobile) {
            image =  imageDict && imageDict['mobile'] ? imageDict['mobile'] : imageDict && imageDict['default']
        } else if (isTablet) {
            image =  imageDict && imageDict['tablet']? imageDict['tablet'] : imageDict && imageDict['default']
        } else {
            image =  imageDict && imageDict['desktop']? imageDict['desktop'] : imageDict && imageDict['default']
        }
        return getStaticPath(image)
    }
    return getStaticPath(imageDict); // image is string i.e path
}

class FeatureTwoRowComponent extends React.PureComponent<Props> {
    render() {
        const props = this.props;
        return (
            <Fragment>
                <Section className={`${styles.banner_title} ${props.sectionClass}`} hasPadding={true} title={props.title ? props.title: ''} dataBg={props.isGreyBackground ? "shade-2":''} id={props.elementID ? props.elementID : ''}>
                        <div className="container">
                            <div className={`row ${styles.feature_list} ${props.className? props.className: ''}` }>
                               { props.features && props.features.map((feature, index)=>{
                                  return (
                                    <Fragment key={`key-two-row-${index}`}>
                                        <div className={`col-6 col-sm-6 col-md-6 col-lg-4 ${styles.feature_item} ${styles.feature_item__double_row}  ${props.itemClassName? props.itemClassName: ''}` } >
                                            <div
                                                className={`${styles.feature_item__image} ${styles.feature_item_image__double_row}`}
                                                style={{ 'backgroundImage': `url(${getImage(feature.featureImage)}` }}
                                            ></div>
                                            <div className={feature.featureTitle  ? ` ${styles.feature_item__text} ${styles.item_text__double_row} ${styles.feature_item__subtext} ${styles.no_margin_double_row}` : ` ${styles.feature_item__text}`}>
                                                {feature.featureTitle  &&
                                                    <div className={`${styles.feature_item__title} ${styles.title__double_row}`}>
                                                        <p className="level-one">{feature.featureTitle}</p>
                                                    </div>}
                                                <p className={feature.featureTitle  ? `${styles.feature_desc} level-two` : `${styles.feature_desc} level-one` }>{feature.featureText}</p>
                                            </div>
                                        </div>
                                    </Fragment>
                                )})
                              }
                            </div>
                        </div>
                </Section>
            </Fragment>
        )
    }

}

export default FeatureTwoRowComponent;
